import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SEARCH_FORMS_REQUEST = 'SEARCH_FORMS_REQUEST';
export const SEARCH_FORMS_SUCCESS = 'SEARCH_FORMS_SUCCESS';
export const SEARCH_FORMS_FAILURE = 'SEARCH_FORMS_FAILURE';

function requestSearchForms() {
  return {
    type: SEARCH_FORMS_REQUEST,
    isGettingForms: true
  };
}

function receiveSearchForms(forms, formsCount, gridTotalLimit) {
  return {
    type: SEARCH_FORMS_SUCCESS,
    isGettingForms: false,
    forms,
    formsCount,
    gridTotalLimit
  };
}

function rejectSearchForms() {
  return {
    type: SEARCH_FORMS_FAILURE,
    isGettingForms: false
  };
}

export function searchForms(pageNumber, pageSize, sortBy, sortDirection, filters, accountNumber, clientId, customer, legalEntity, searchQuery) {
  return (dispatch) => {
    dispatch(requestSearchForms());
    const promise = () => ApiService
      .searchForms(pageNumber, pageSize, sortBy, sortDirection, filters, accountNumber, clientId, customer, legalEntity, searchQuery)
      .then((response) => {
        dispatch(receiveSearchForms(response.data.forms, response.data.totalCount, response.data.totalLimit));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSearchForms, true));
        }
      });
    return promise();
  };
}
